import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";

export const useFetchBrands = () => {
  return useQuery({
    queryKey: ["brands"],
    queryFn: async () => {
      const response = await makeApiRequest({
        endpoint: "/api/brands",
        method: "GET"
      });
      return response;
    },
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
};
